module.exports = __webpack_public_path__ + "static/media/Group 922.92614754.svg";